import { render, staticRenderFns } from "./AltraQualita.vue?vue&type=template&id=c4191588"
import script from "./AltraQualita.vue?vue&type=script&lang=js"
export * from "./AltraQualita.vue?vue&type=script&lang=js"
import style0 from "./AltraQualita.vue?vue&type=style&index=0&id=c4191588&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports